import { gql } from '@apollo/client'

// Query to get a list of creditors based on filters
export const CREDITORS_QUERY = gql`
  query Creditors($filters: CreditorFilters!) {
    creditors(filters: $filters) {
      walletID
      creditorID
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
      walletBalance
      remainingCreditBalance
      remainingReservable
      active
      autoSettelmentEnabled
      maxCredit
    }
  }
`

// Query to get a specific creditor by ID
export const CREDITOR_QUERY = gql`
  query Creditor($creditorID: ID!) {
    creditor(creditorID: $creditorID) {
      walletID
      creditorID
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
      walletBalance
      remainingCreditBalance
      remainingReservable
      maxCredit
      macReservable
      canUseCredit
      autoSettelmentEnabled
      active
    }
  }
`

// Query to get a brief list of creditors based on filters
export const CREDITORS_BRIEF_QUERY = gql`
  query CreditorsBrief($walletID: ID!) {
    creditorsBrief(walletID: $walletID) {
      creditorID
      entity {
        entityType
        entityID
        entityCode
        entityName
        displayEntityCode
      }
    }
  }
`

export const ADD_CREDITOR_MUTATION = gql`
  mutation AddCreditors($input: AddCreditorsRequestInput!) {
    addCreditors(input: $input) {
      message
    }
  }
`

export const UPDATE_CREDITOR_MUTATION = gql`
  mutation UpdateCreditor($input: UpdateCreditorInput!) {
    updateCreditor(input: $input) {
      message
    }
  }
`
